import axios from 'axios';

export const dataPortalRefreshConflictDeadlineMs = 12_000;
export const dataPortalRefreshConflictMaxDelayMs = 2_000;

export const dataPortalApiBaseUrl =
  import.meta.env.VITE_DATAPORTAL_API_BASE_URL || '/api/data-portal';

export const dataPortalClient = axios.create({
  baseURL: dataPortalApiBaseUrl,
  timeout: 0,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
});

export function dataPortalHttpStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

export function dataPortalRetryAfterMs(value: unknown): number {
  if (typeof value !== 'string') return 0;
  const seconds = Number(value);
  if (Number.isFinite(seconds) && seconds >= 0) return seconds * 1_000;
  const date = Date.parse(value);
  return Number.isFinite(date) ? Math.max(0, date - Date.now()) : 0;
}

dataPortalClient.interceptors.request.use((config) => {
  if (typeof config.headers?.delete === 'function') {
    config.headers.delete('Authorization');
  } else if (config.headers) {
    delete config.headers.Authorization;
  }
  return config;
});
